"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomString = void 0;
function randomString(length) {
    if (length === void 0) { length = 16; }
    var str = "";
    while (str.length < length) {
        str += Math.round(Math.random() * 2147483647).toString(36);
    }
    return str.substr(0, length);
}
exports.randomString = randomString;
//# sourceMappingURL=utils.js.map